import { memo } from "react";
import { useSnackbarStore } from "./snackbar.store";
import { SnackbarItem } from "./snackbar-item";

export const SnackbarList = memo(() => {
	const messages = useSnackbarStore((s) => s.messages);

	return (
		<>
			{messages.map((m) => (
				<SnackbarItem key={m.id} {...m} />
			))}
		</>
	);
});
SnackbarList.displayName = "SnackbarList";
